import type { AnalyticsHeaderFooterLinkProps } from 'src/modules/analytics/types';

export const TRACKED_LINK_CLICKED = 'TRACKED_LINK_CLICKED';
export const COMPANY_REVIEWS_LINK_CLICKED = 'COMPANY_REVIEWS_LINK_CLICKED';
export const HEADER_FOOTER_LINK_CLICKED = 'HEADER_FOOTER_LINK_CLICKED';

export const headerFooterLinkClicked = ({
  linkPosition,
  linkText,
  linkAction,
}: AnalyticsHeaderFooterLinkProps) => ({
  type: HEADER_FOOTER_LINK_CLICKED,
  payload: {
    linkPosition,
    linkText,
    linkAction,
  },
});

export const externalLinkClicked = (
  link?: string | Record<string, unknown>,
) => ({
  type: TRACKED_LINK_CLICKED,
  payload: link,
});

export const companyReviewsLinkClicked = (companyName: string) => ({
  type: COMPANY_REVIEWS_LINK_CLICKED,
  payload: {
    companyName,
  },
});
